export const songList = [
  {
    id: "14",
    title: "एक और ट्राय",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/One_more_try/Hindi_Version_2/ek-or-bar-hindi.mp3",
    language: "Hindi",
  },
  {
    id: "15",
    title: "ఇంకో ప్రయత్నం",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/One_more_try/Telugu/telgu.mp3",
    language: "Telugu",
  },
  {
    id: "16",
    title: "再试一次",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/One_more_try/Chinese/mandarin.mp3",
    language: "Chinese",
  },
  {
    id: "17",
    title: "Un intento más",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/One_more_try/Spanish/spanish.mp3",
    language: "Spanish",
  },
  {
    id: "18",
    title: "محاولة أخرى",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/One_more_try/Arabic/arabic.mp3",
    language: "Arabic",
  },
  {
    id: "19",
    title: "One More Try",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/One_more_try/English/one+more+try_english.mp3",
    language: "English",
  },
  {
    id: "22",
    title: "もう一度試す",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/One_more_try/Japanese/One+More+Try_Japanese.mp3",
    language: "Japanese",
  },
  {
    id: "23",
    title: "Un altro tentativo",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/One_more_try/One+more+try_Italian.mp3",
    language: "Italian",
  },
  {
    id: "24",
    title: "Une autre tentative",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/One_more_try/One+more+try_French.mp3",
    language: "French",
  },
  {
    id: "25",
    title: "Noch ein Versuch",
    url: "https://f003.backblazeb2.com/file/KGM-Songs/One_more_try/One+more+try_German.mp3",
    language: "German",
  },
  {
    id: "72",
    title: "Ещё одна попытка",
    url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/NEW-VERSIONS-ONE-MORE-TRY/NEW%20VERSIONS_ONE%20MORE%20TRY/One_more_try_russian.mp3",
    language: "Russian",
  },
  {
    id: "73",
    title: "Mais uma tentativa",
    url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/NEW-VERSIONS-ONE-MORE-TRY/NEW%20VERSIONS_ONE%20MORE%20TRY/One_more_try_portuguese.mp3",
    language: "Portuguese",
  },
  {
    id: "74",
    title: "Bir Şans Daha",
    url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/NEW-VERSIONS-ONE-MORE-TRY/NEW%20VERSIONS_ONE%20MORE%20TRY/One_more_try_Turkish.mp3",
    language: "Turkish",
  },
  {
    id: "75",
    title: "한 번 더",
    url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/NEW-VERSIONS-ONE-MORE-TRY/NEW%20VERSIONS_ONE%20MORE%20TRY/One_more_try_korean.mp3",
    language: "Korean",
  },
  {
    id: "76",
    title: "आणखी एक प्रयत्न",
    url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/NEW-VERSIONS-ONE-MORE-TRY/NEW%20VERSIONS_ONE%20MORE%20TRY/One_more_try_Marathi.mp3",
    language: "Marathi",
  },
  {
    id: "77",
    title: "એક વધુ પ્રયાસ",
    url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/NEW-VERSIONS-ONE-MORE-TRY/NEW%20VERSIONS_ONE%20MORE%20TRY/One_more_try_Gujrathi.mp3",
    language: "Gujarati",
  },
  {
    id: "78",
    title: "இன்னொரு முயற்சி",
    url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/NEW-VERSIONS-ONE-MORE-TRY/NEW%20VERSIONS_ONE%20MORE%20TRY/One_more_try_Gujrathi.mp3",
    language: "Tamil",
  },
];
